import { render } from "./DeleteInscription.vue?vue&type=template&id=345966d7"
import script from "./DeleteInscription.vue?vue&type=script&lang=js"
export * from "./DeleteInscription.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__